import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { LoginComponent, LoginResponse } from '../login/login.component';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    standalone: false
})
export class AuthenticationComponent implements OnInit {

  authenticate: LoginResponse;
  canEnableHelp: boolean = false;


  constructor(private service: AppService, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<LoginComponent>,  private dialog: MatDialog) { }

  ngOnInit() {
    this.InitializeForm();
  }

  /** Submit button event for authentication form */
  OnSubmitClick() {
    let isValid = false;
    if (this.authenticate.twoFactor && this.authenticate.challengeQuestion) {
      if (this.authenticate.userCode && this.authenticate.userAnswer) {
        isValid = true;
      }
    } else {
      if (this.authenticate.twoFactor) {
        if (this.authenticate.userCode) {
          isValid = true;
        }
      }

      if (this.authenticate.challengeQuestion) {
        if (this.authenticate.userAnswer) {
          isValid = true;
        }
      }
    }

    if (isValid) {
      this.service.showSpinner();
      this.http.post<GRSSResponse>(this.baseUrl + 'api/auth/authenticate', this.authenticate).subscribe(result => {
        if (result.statusCode === 1) {
          this.dialogRef.close();
        } else {
          this.service.SaveStatus(false, 'Auth.Messages.msgHeaderLogin', result.statusMessage);
        }
      }, error => {
        console.error(error);
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

  resendTwoFactor() {
    this.service.showSpinner();
    this.http.post<GRSSResponse>(this.baseUrl + 'api/auth/resendTwofactor', this.service.userTemp).subscribe(result => {
      if (result.statusCode === 1) {
        this.canEnableHelp = true;
      }
      this.service.SaveStatus(false, 'Auth.Messages.msgHeaderTwoFac', result.statusMessage);
    }, error => {
      console.error(error);
    }).add(() => {
      this.service.hideSpinner();
    });
  }

  /** Initializes the form values */
  InitializeForm() {
    this.authenticate = {
      challengeQuestion: this.data.challengeQuestion,
      question: this.data.question,
      responseStatus: this.data.responseStatus,
      twoFactor: this.data.twoFactor,
      userId: this.data.userId,
      isTemporary: this.data.isTemporary,
      userAnswer: '',
      userCode: '',
      isExpired: this.data.isExpired,
      expiresIn: this.data.expiresIn
    };
  }

}
